import service from '@/api/service/service';
import qs from "qs";

/* 分类、难度 */
export function category_difficult(params = {}) {
  return service({
    url: "/api/plan/category_skill_list.json",
    method: 'get',
    params: params,
  });
}
/* 我的教案 */
export function myTutorial(params = {}) {
  return service({
    url: "/api/plan/my_plan_list.json",
    method: 'get',
    params: params,
  });
}
/* 资源库 */
export function allTutorial(data = {}) {
  return service({
    url: "/api/plan/library_list.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 教案详情 */
export function tutorialDetail(data = {}) {
  return service({
    url: "/api/plan/view_plan.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 优秀教案 */
export function excellentTutorial(data = {}) {
  return service({
    url: "/api/plan/recommend_excellent_plan.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 下载教案PDF */
export function downloadTutorial(data = {}) {
  return service({
    url: "/api/plan/view_pdf_download.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 删除教案 */
export function deleteTutorial(data = {}) {
  return service({
    url: "/api/plan/delete_plan.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 更改教案类型 */
export function tutorialType(data = {}) {
  return service({
    url: "/api/plan/update_plan_type.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

/* 更改教案共享状态 */
export function tutorialStatus(data = {}) {
  return service({
    url: "/api/plan/update_sharing_status.json",
    method: 'post',
    data: qs.stringify(data),
  });
}

// 获取需要测评的教师、机构
export function getStuRatingInfo(params = {}) {
  return service({
    url: '/api/evaluation/student_evaluation_data.json',
    method: 'get',
    params,
  })
}

// 保存评价的结果
export function saveEvaluat(data = {}) {
  return service({
    url: '/api/evaluation/stu_evaluation_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 判断学员的培训班是否测评了
export function isEvaluated(params = {}) {
  return service({
    url: '/api/evaluation/opinion_student_eva.json',
    method: 'get',
    params,
  })
}
// 到期学院资质提交
export function qualification_submit(data = {}) {
  return service({
    url: '/api/organization/qualification_submit.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

/* 补充已确认培训历程信息 */
export function completeExpirence(data) {
  return service({
    url: '/api/achievement/achievement_perfect_information',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 继续教育抽题使用
export function isRandomQuestion(params = {}) {
  return service({
    url: '/api/plan/student_random_question.json',
    method: 'get',
    params,
  })
}
/* 获取教练员注册申请默认信息 */
export function getDetaultInfoForAlteration(data) {
  return service({
    url: '/api/transfer/coach_transfer_report_view.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 获取教练员注册申请默认信息 */
export function postAlterationInfo(data) {
  return service({
    url: '/api/transfer/coach_transfer_submit.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/* 获取教练员注册申请 状态 */
export function getAlterationStatus(params) {
  return service({
    url: '/api/transfer/transfer_audit_status.json',
    // method: 'POST',
    method: 'GET',
    params
    // data: qs.stringify(data)
  })
}
/* 教练员申请被拒绝后 提出复议的信息返回 */
export function coachTransferFuyiInfoReturn(params) {
  return service({
    url: '/api/transfer/coach_transfer_fuyi_info_return.json',
    method: 'GET',
    params
  })
}
/* 教练员申请被拒绝后 提出复议 */
export function coachTransferFuyiSave(data) {
  return service({
    url: '/api/transfer/coach_transfer_fuyi_save.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}
/* 学员查看 预录取通道的详情 */
export function pre_admission_info(params) {
  return service({
    url: '/api/highTrain/pre_admission_info.json',
    method: 'GET',
    params
  })
}
/* 教练员申请被拒绝后 提出复议 */
export function pre_admission_status_save(data) {
  return service({
    url: '/api/highTrain/pre_admission_status_save.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}
/* 检查该球员是不是高水平球员 */
export function high_player_certification_check(params) {
  return service({
    url: '/api/authentication/high_player_certification_check.json',
    method: 'GET',
    params
  })
}
/* 球员认证高水平球员 */
export function high_player_certification(data) {
  return service({
    url: '/api/authentication/high_player_certification.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}
